module.exports = __webpack_public_path__ + "img/mobile-40.0c0a3b19.png";